/**
 * Russian strings of the 09 inbox (see `uz-09-inbox.ts`). Spread into `ru`; a key missing here
 * falls back to Uzbek like every other.
 */
import type { TranslationKey } from "./uz";

export const ruInbox09: Partial<Record<TranslationKey, string>> = {
  "inbox09.own.label": "Чьи",
  "inbox09.own.mine": "Мои",
  "inbox09.own.unclaimed": "Не взяты",
  "inbox09.own.all": "Все",
  "inbox09.state.label": "Статус",
  "inbox09.state.awaiting": "Ждут ответа",
  "inbox09.state.pending_draft": "Ответ AI на проверке",
  "inbox09.state.overdue": "Просрочены",
  "inbox09.state.closed": "Закрыты",
  "inbox09.channel.label": "Канал",
  "inbox09.channel.all": "Все",
  "inbox09.channel.telegram": "Telegram",
  "inbox09.channel.instagram": "Instagram Direct",
  "inbox09.channel.instagram_comment": "Комментарии Instagram",
  "inbox09.live": "В реальном времени",
  "inbox09.liveRetrying": "Переподключение",
  "inbox09.search.label": "Поиск по диалогам",
  "inbox09.search.placeholder": "Имя, телефон или сообщение",
  "inbox09.section.inbox": "Диалоги",
  "inbox09.section.comments": "Комментарии Instagram",
  "inbox09.section.nav": "Диалоги и комментарии",

  "inbox09.list.label": "Список диалогов",
  "inbox09.list.error": "Не удалось загрузить диалоги.",
  "inbox09.list.empty": "В этом разделе нет диалогов.",
  "inbox09.list.unknownClient": "Неизвестный клиент",
  "inbox09.list.unread": "Непрочитанных: {count}",
  "inbox09.list.aiMark": "Отвечает AI",
  "inbox09.list.claim": "Взять",
  "inbox09.list.pick": "Выбрать {name}",
  "inbox09.list.waiting": "Ждёт: {time}",
  "inbox09.retry": "Повторить",
  "inbox09.time.now": "сейчас",
  "inbox09.time.minutes": "{count} мин",
  "inbox09.time.hours": "{hours} ч {minutes} мин",
  "inbox09.time.yesterday": "вчера",
  "inbox09.claim.done": "Диалог закреплён за вами.",
  "inbox09.claim.taken": "Этот диалог уже взял(а) {name}.",
  "inbox09.claim.failed": "Не удалось взять диалог.",
  "inbox09.comment.kind": "Комментарий Instagram",
  "inbox09.comment.status": "Ждёт ответа",
  "inbox09.comment.empty": "Нет комментариев, ждущих ответа.",
  "inbox09.comment.error": "Не удалось загрузить комментарии.",

  "inbox09.queue.title": "Обращения",
  "inbox09.queue.tableLabel": "Обращения в свободной очереди",
  "inbox09.queue.col.client": "Клиент",
  "inbox09.queue.col.need": "Потребность по данным AI",
  "inbox09.queue.col.wait": "Ждёт",
  "inbox09.queue.col.actions": "Действия",
  "inbox09.queue.empty": "В свободной очереди нет обращений.",
  "inbox09.queue.error": "Не удалось загрузить обращения.",
  "inbox09.queue.needNone": "Потребность ещё не определена",
  "inbox09.queue.filterBranch": "Филиал",
  "inbox09.queue.allBranches": "Все филиалы",
  "inbox09.queue.assign": "Назначить",
  "inbox09.queue.assignTitle": "Назначить обращение",
  "inbox09.queue.assignPick": "Сотрудник",
  "inbox09.queue.assignDone": "Обращение назначено: {name}.",
  "inbox09.queue.assignFailed": "Не удалось назначить.",
  "inbox09.queue.claimed": "Обращение закреплено за вами.",
  "inbox09.need.destination": "Направление",
  "inbox09.need.dates": "Даты",
  "inbox09.need.adults": "Взрослых: {count}",
  "inbox09.need.children": "Детей: {count}",
  "inbox09.need.service": "Услуга",
  "inbox09.need.byAi": "Определено AI",

  "inbox09.header.handover": "Передать другому",
  "inbox09.header.createDeal": "Создать сделку",
  "inbox09.header.close": "Закрыть",
  "inbox09.header.closed": "Диалог закрыт.",
  "inbox09.header.closeFailed": "Не удалось закрыть диалог.",
  "inbox09.header.dealCreated": "Сделка создана.",
  "inbox09.header.dealExists": "У клиента есть открытая сделка, диалог привязан к ней.",
  "inbox09.header.dealFailed": "Не удалось создать сделку.",
  "inbox09.header.handoverTitle": "Передать диалог",
  "inbox09.header.handoverPick": "Кому",
  "inbox09.header.handoverSubmit": "Передать",
  "inbox09.header.handoverDone": "Диалог передан: {name}.",
  "inbox09.header.handoverFailed": "Не удалось передать диалог.",
  "inbox09.header.membersError": "Не удалось загрузить список сотрудников.",
  "inbox09.header.cancel": "Отмена",

  "inbox09.draft.label": "Ответ AI на проверке",
  "inbox09.draft.source": "Источник: {sources}",
  "inbox09.draft.noSource": "Источник: цитат из базы знаний нет",
  "inbox09.draft.send": "Отправить",
  "inbox09.draft.edit": "Изменить",
  "inbox09.draft.reject": "Отклонить",
  "inbox09.draft.rejectReason": "Причина отклонения",
  "inbox09.draft.rejectPlaceholder": "Что не так?",
  "inbox09.draft.sendFailed": "Не удалось отправить черновик.",
  "inbox09.draft.rejectFailed": "Не удалось отклонить черновик.",
  "inbox09.draft.notYours": "Ответ подтверждает сотрудник, взявший диалог.",
  "inbox09.bubble.aiSent": "Отправил AI · {time}",
  "inbox09.bubble.approvedBy": "Подтвердил(а) {name}",
  "inbox09.bubble.client": "Сообщение клиента",
  "inbox09.note.label": "Внутренняя заметка",
  "inbox09.note.hidden": "(клиент не видит)",

  "inbox09.composer.template": "Шаблон",
  "inbox09.composer.tour": "Прикрепить тур",
  "inbox09.composer.checklist": "Список документов",
  "inbox09.composer.note": "Внутренняя заметка",
  "inbox09.composer.file": "Файл",
  "inbox09.composer.noteOn": "Внутренняя заметка: видит команда, клиенту не уходит.",
  "inbox09.composer.notePlaceholder": "Заметка для команды",
  "inbox09.composer.saveNote": "Сохранить заметку",
  "inbox09.composer.noteFailed": "Не удалось сохранить заметку.",
  "inbox09.composer.checklistFailed": "Не удалось получить список документов.",

  "inbox09.panel.label": "Данные клиента",
  "inbox09.panel.error": "Не удалось загрузить данные.",
  "inbox09.panel.noClient": "Клиент не определён",
  "inbox09.panel.source": "Источник",
  "inbox09.panel.firstContact": "Первое обращение",
  "inbox09.panel.returning": "Повторный клиент",
  "inbox09.panel.need": "Потребность по данным AI",
  "inbox09.panel.needEmpty": "Ещё не определена",
  "inbox09.panel.createDealWithNeed": "Создать сделку с этими данными",
  "inbox09.panel.visa": "Документы",
  "inbox09.panel.visaProgress": "({passed} / {total})",
  "inbox09.panel.sendChecklist": "Отправить список документов",
  "inbox09.panel.trips": "Прошлые поездки",
  "inbox09.panel.tripsEmpty": "Раньше не путешествовал(а)",
  "inbox09.panel.tasks": "Задачи",
  "inbox09.panel.tasksEmpty": "Открытых задач нет",
  "inbox09.panel.addTask": "+ Добавить задачу",
  "inbox09.panel.call": "Звонок",
  "inbox09.panel.card": "Карточка клиента",

  "inbox09.commentView.label": "Комментарий Instagram",
  "inbox09.commentView.post": "Открыть пост",
  "inbox09.commentView.public": "Публичный ответ",
  "inbox09.commentView.direct": "Перевести в Direct",
  "inbox09.commentView.text": "Текст ответа",
  "inbox09.commentView.publicSent": "Публичный ответ отправлен.",
  "inbox09.commentView.directSent": "Сообщение в Direct отправлено.",
  "inbox09.commentView.failed": "Не удалось отправить ответ.",
};
